module.exports = __webpack_public_path__ + "img/shippingbannermini.31fc48cc.png";